// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c85875c9","455":"831c443d"}[chunkId] + ".chunk.js";
};